export default class ResultsScreen {
  constructor({ onRetry, onMenu, onShare, onPass }) {
    this.onRetry = onRetry;
    this.onMenu = onMenu;
    this.onShare = onShare;
    this.onPass = onPass;

    document.getElementById('btn-retry')?.addEventListener('click', () => this.onRetry?.());
    document.getElementById('btn-menu')?.addEventListener('click', () => this.onMenu?.());
    document.getElementById('btn-results-pass')?.addEventListener('click', () => this.onPass?.());

    const shareBtn = document.getElementById('btn-share');
    shareBtn?.addEventListener('click', async () => {
      shareBtn.disabled = true;
      try {
        await this.onShare?.();
      } finally {
        shareBtn.disabled = false;
      }
    });
  }

  setShareFeedback(message) {
    const el = document.getElementById('share-feedback');
    if (!el) return;
    el.textContent = message || '';
    el.classList.toggle('hidden', !message);
  }

  show(result, { isNewRecord = false, showPass = false } = {}) {
    const setText = (id, value) => {
      const el = document.getElementById(id);
      if (el) el.textContent = String(value ?? '');
    };

    const labels = { easy: 'FACILE', normal: 'NORMAL', hard: 'DIFFICILE' };
    const difficulty = labels[result.difficulty] || 'NORMAL';
    const title = String(result.songTitle || 'Résultats').replace(/<[^>]*>/g, '').slice(0, 80);
    setText('results-title', `${title} · ${difficulty}`);
    setText('results-grade', result.grade || 'C');
    setText('results-score', Math.floor(result.score || 0));
    setText('results-combo', Math.floor(result.maxCombo || 0));
    setText('results-perfect', result.perfect || 0);
    setText('results-good', result.good || 0);
    setText('results-miss', result.miss || 0);
    setText('results-holds', result.holds || 0);
    setText('results-overdrive', `${Number(result.overdriveSeconds || 0).toFixed(1)}s`);

    const universeEl = document.getElementById('results-universe');
    if (universeEl) {
      const universe = result.universe;
      universeEl.textContent = universe
        ? `UNIVERSE BORN · ${universe.name} · ${universe.era}`
        : '';
      universeEl.classList.toggle('hidden', !universe);
    }

    const record = document.getElementById('results-record');
    if (record) record.classList.toggle('hidden', !isNewRecord);

    const gradeEl = document.getElementById('results-grade');
    if (gradeEl) {
      const colors = { S: '#c7ff45', A: '#526dff', B: '#f3f4f6', C: '#858a96' };
      gradeEl.style.color = colors[result.grade] || colors.C;
    }

    // The leaderboard arrives asynchronously (see setLeaderboard); hide it until then.
    document.getElementById('results-leaderboard')?.classList.add('hidden');
    document.getElementById('results-pass')?.classList.toggle('hidden', !showPass);
    this.setShareFeedback('');
  }

  /** World top 5 + personal rank, injected once the server answered. */
  setLeaderboard(data, currentUsername) {
    const block = document.getElementById('results-leaderboard');
    const list = document.getElementById('results-lb-list');
    const meEl = document.getElementById('results-lb-me');
    if (!block || !list || !data) return;

    list.textContent = '';
    for (const entry of data.entries.slice(0, 5)) {
      const li = document.createElement('li');
      if (currentUsername && entry.username === currentUsername) li.classList.add('is-me');
      const name = document.createElement('span');
      name.textContent = `#${entry.rank} ${entry.username}`;
      const score = document.createElement('span');
      score.textContent = entry.score.toLocaleString('fr-FR');
      li.append(name, score);
      list.appendChild(li);
    }

    if (meEl) {
      if (data.me && data.me.eligible === false) {
        meEl.textContent = 'VALIDE TON EMAIL POUR APPARAÎTRE AU CLASSEMENT PUBLIC';
      } else {
        meEl.textContent = data.me?.rank ? `TOI · #${data.me.rank} MONDIAL` : '';
      }
    }
    block.classList.remove('hidden');
  }
}
